import { type ReactNode } from "react";

interface MessageContainerBoxProps {
  children?: ReactNode;
  className?: string;
  id?: string;
}

const MessageContainerBox = (props: MessageContainerBoxProps) => {
  const { className, id } = props;

  return (
    <div className={`scha__bulk-add__msg-box ${className ? className : ""}`} id={id ? id : undefined}>
      {props.children}
    </div>
  );
};

export default MessageContainerBox;
